import { IconButton, makeStyles } from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.secondary.contrastText,
  },
  text: {
    //textTransform: "uppercase",
    fontSize: "0.7em",
    display: "inline-block",
    marginTop: 3,
  },
}));

type Props = {
  dirtyFields: { [key: string]: any };
  dataTest?: string;
};

export const AppBarDirtyIndicator: React.FC<Props> = ({ dirtyFields, dataTest }) => {
  const classes = useStyles();
  const dirtyCount = recurseCountKeys(dirtyFields);

  return (
    <>
      {!!dirtyCount && (
        <IconButton classes={{ root: classes.root }} data-testid={dataTest}>
          <Warning />{" "}
          <span className={classes.text}>
            &nbsp;
            {dirtyCount && "There are unsaved changes"}
          </span>
        </IconButton>
      )}
    </>
  );
};

const recurseCountKeys = (
  errorObject: { [key: string]: any } | { [key: string]: any }[]
) => {
  let count = 0;

  if (Array.isArray(errorObject)) {
    errorObject.forEach((item) => {
      count += recurseCountKeys(item);
    });
  } else {
    Object.keys(errorObject).forEach((key) => {
      if (Array.isArray(errorObject[key])) {
        count += recurseCountKeys(errorObject[key]);
      } else {
        count += 1;
      }
    });
  }

  return count;
};
